import apiClient from "@/clients/apiClient";
import type { GenContenidoNosotrosPayload } from "../interfaces/genContenidoNosotros.interface";

type ApiEnvelope<T> = { data: T; message: string; status: number };

export async function updateGenContenidoNosotrosAction(
  body: GenContenidoNosotrosPayload
): Promise<GenContenidoNosotrosPayload> {
  const res =
    await apiClient.patch<ApiEnvelope<GenContenidoNosotrosPayload>>(
      "genContenidoNosotros",
      body
    );
  return res.data.data;
}
